
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import { devsistersCiColorBrightOrange } from '@devsisters/ui-common';
import { CloseIcon } from '@devsisters/ui-careers';
import { PrevIcon, NextIcon } from '@devsisters/ui-careers';
import { CardButtonIcon } from '@devsisters/ui-careers';
import { SearchIcon, ClearInputIcon } from '@devsisters/ui-careers';
import { DropdownIcon, DropdownSelectedIcon } from '@devsisters/ui-careers';
import {
  ShareLinkIcon,
  ShareFacebookIcon,
  ShareTwitterIcon,
  ShareKakaoTalkIcon,
  ShareLinkedInIcon,
} from '@devsisters/ui-careers';
import { GoBackIcon } from '@devsisters/ui-careers';
import { ErrorIcon } from '@devsisters/ui-careers';
import { QuestionIcon } from '@devsisters/ui-careers';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"icons"}}>{`icons`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"closeicon"}}>{`CloseIcon`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { CloseIcon } from '@devsisters/ui-careers';
// 또는 import { CloseIcon } from '@devsisters/ui-careers/lib/icons';
`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"previcon-nexticon"}}>{`PrevIcon, NextIcon`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { PrevIcon, NextIcon } from '@devsisters/ui-careers';
// 또는 import { PrevIcon, NextIcon } from '@devsisters/ui-careers/lib/icons';
`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"cardbuttonicon"}}>{`CardButtonIcon`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { CardButtonIcon } from '@devsisters/ui-careers';
// 또는 import { CardButtonIcon } from '@devsisters/ui-careers/lib/icons';
`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"searchicon-clearinputicon"}}>{`SearchIcon, ClearInputIcon`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { SearchIcon, ClearInputIcon } from '@devsisters/ui-careers';
// 또는 import { SearchIcon, ClearInputIcon } from '@devsisters/ui-careers/lib/icons';
`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"dropdownicon-dropdownselectedicon"}}>{`DropdownIcon, DropdownSelectedIcon`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { DropdownIcon, DropdownSelectedIcon } from '@devsisters/ui-careers';
// 또는 import { DropdownIcon, DropdownSelectedIcon } from '@devsisters/ui-careers/lib/icons';
`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"sharelinkicon-sharefacebookicon-sharetwittericon-sharekakaotalkicon-sharelinkedinicon"}}>{`ShareLinkIcon, ShareFacebookIcon, ShareTwitterIcon, ShareKakaoTalkIcon, ShareLinkedInIcon`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import {
  ShareLinkIcon,
  ShareFacebookIcon,
  ShareTwitterIcon,
  ShareKakaoTalkIcon,
  ShareLinkedInIcon,
} from '@devsisters/ui-careers';
// 또는 ... from '@devsisters/ui-careers/lib/icons';
`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"gobackicon"}}>{`GoBackIcon`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { GoBackIcon } from '@devsisters/ui-careers';
// 또는 import { GoBackIcon } from '@devsisters/ui-careers/lib/icons';
`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"erroricon"}}>{`ErrorIcon`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { ErrorIcon } from '@devsisters/ui-careers';
// 또는 import { ErrorIcon } from '@devsisters/ui-careers/lib/icons';
`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"questionicon"}}>{`QuestionIcon`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { QuestionIcon } from '@devsisters/ui-careers';
// 또는 import { QuestionIcon } from '@devsisters/ui-careers/lib/icons';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<h2>CloseIcon</h2>\n<CloseIcon style={{ fontSize: \'30px\' }} />\n<h2>PrevIcon, NextIcon</h2>\n<div style={{ display: \'flex\', justifyContent: \'space-around\' }}>\n  <PrevIcon\n    style={{ fontSize: \'55px\', color: devsistersCiColorBrightOrange }}\n  />\n  <br />\n  <NextIcon\n    style={{ fontSize: \'55px\', color: devsistersCiColorBrightOrange }}\n  />\n</div>\n<h2>CardButtonIcon</h2>\n<CardButtonIcon\n  style={{ fontSize: \'25px\', color: devsistersCiColorBrightOrange }}\n/>\n<h2>SearchIcon, ClearInputIcon</h2>\n<div style={{ display: \'flex\', justifyContent: \'space-around\' }}>\n  <SearchIcon\n    style={{ fontSize: \'22px\', color: devsistersCiColorBrightOrange }}\n  />\n  <ClearInputIcon style={{ fontSize: \'22px\' }} />\n</div>\n<h2>DropdownIcon, DropdownSelectedIcon</h2>\n<div style={{ display: \'flex\', justifyContent: \'space-around\' }}>\n  <DropdownIcon style={{ fontSize: \'15px\' }} />\n  <DropdownIcon style={{ fontSize: \'15px\', transform: \'rotate(180deg)\' }} />\n  <DropdownSelectedIcon\n    style={{ fontSize: \'16px\', color: devsistersCiColorBrightOrange }}\n  />\n</div>\n<h2>\n  ShareLinkIcon, ShareFacebookIcon, ShareTwitterIcon, ShareKakaoTalkIcon,\n  ShareLinkedInIcon\n</h2>\n<div style={{ display: \'flex\', justifyContent: \'space-around\' }}>\n  <ShareLinkIcon style={{ fontSize: \'35px\' }} />\n  <ShareFacebookIcon style={{ fontSize: \'35px\' }} />\n  <ShareTwitterIcon style={{ fontSize: \'35px\' }} />\n  <ShareKakaoTalkIcon style={{ fontSize: \'35px\' }} />\n  <ShareLinkedInIcon style={{ fontSize: \'35px\' }} />\n</div>\n<h2>GoBackIcon</h2>\n<GoBackIcon style={{ fontSize: \'15px\' }} />\n<h2>ErrorIcon</h2>\n<ErrorIcon style={{ fontSize: \'18px\', color: \'red\' }} />\n<h2>QuestionIcon</h2>\n<QuestionIcon\n  style={{ fontSize: \'18px\', color: devsistersCiColorBrightOrange }}\n/>'} __scope={{props: this ? this.props : props,devsistersCiColorBrightOrange,CloseIcon,PrevIcon,NextIcon,CardButtonIcon,SearchIcon,ClearInputIcon,DropdownIcon,DropdownSelectedIcon,ShareLinkIcon,ShareFacebookIcon,ShareTwitterIcon,ShareKakaoTalkIcon,ShareLinkedInIcon,GoBackIcon,ErrorIcon,QuestionIcon}}>
  <h2>CloseIcon</h2>
  <CloseIcon style={{ fontSize: '30px' }}/>
  <h2>PrevIcon, NextIcon</h2>
  <div style={{ display: 'flex', justifyContent: 'space-around' }}>
    <PrevIcon style={{ fontSize: '55px', color: devsistersCiColorBrightOrange }}/><br/>
    <NextIcon style={{ fontSize: '55px', color: devsistersCiColorBrightOrange }}/>
  </div>
  <h2>CardButtonIcon</h2>
  <CardButtonIcon style={{ fontSize: '25px', color: devsistersCiColorBrightOrange }}/>
  <h2>SearchIcon, ClearInputIcon</h2>
  <div style={{ display: 'flex', justifyContent: 'space-around' }}>
    <SearchIcon style={{ fontSize: '22px', color: devsistersCiColorBrightOrange }}/>
    <ClearInputIcon style={{ fontSize: '22px' }}/>
  </div>
  <h2>DropdownIcon, DropdownSelectedIcon</h2>
  <div style={{ display: 'flex', justifyContent: 'space-around' }}>
    <DropdownIcon style={{ fontSize: '15px' }}/>
    <DropdownIcon style={{ fontSize: '15px', transform: 'rotate(180deg)' }}/>
    <DropdownSelectedIcon style={{ fontSize: '16px', color: devsistersCiColorBrightOrange }}/>
  </div>
  <h2>ShareLinkIcon, ShareFacebookIcon, ShareTwitterIcon, ShareKakaoTalkIcon, ShareLinkedInIcon</h2>
  <div style={{ display: 'flex', justifyContent: 'space-around' }}>
    <ShareLinkIcon style={{ fontSize: '35px' }}/>
    <ShareFacebookIcon style={{ fontSize: '35px' }}/>
    <ShareTwitterIcon style={{ fontSize: '35px' }}/>
    <ShareKakaoTalkIcon style={{ fontSize: '35px' }}/>
    <ShareLinkedInIcon style={{ fontSize: '35px' }}/>
  </div>
  <h2>GoBackIcon</h2>
  <GoBackIcon style={{ fontSize: '15px' }}/>
  <h2>ErrorIcon</h2>
  <ErrorIcon style={{ fontSize: '18px', color: 'red' }}/>
  <h2>QuestionIcon</h2>
  <QuestionIcon style={{ fontSize: '18px', color: devsistersCiColorBrightOrange }}/>
</Playground>
           </MDXTag>
  }
}
  